import { useQuery } from "@tanstack/react-query";
import { useAgentEditorApi } from "../services/api/useAgentEditorApi";
import { IAgent } from "../types/base";

export function useAdminAgents() {
  const agentEditorService = useAgentEditorApi();

  // const pathname = usePathname();
  // const isFactoryPage = pathname.startsWith("/factory");

  return useQuery<IAgent[]>({
    queryKey: ["admin-agents"],
    queryFn: async () => {
      return await agentEditorService.fetchAdminAgents();
    },
    // staleTime: 30 * 1000, // 30 seconds
    retry: false,
    // enabled: true,
  });
}
